const StatusCodeMessages = {
  400: 'Oops! Something went wrong with your request.',
  401: 'You need to log in to access this page.',
  403: 'You don’t have permission to view this page.',
  404: 'The page you’re looking for doesn’t exist.',
  500: 'Something broke on our end. We’re fixing it!',
  502: 'We’re having trouble connecting to the server. Please try again later.',
};

Object.freeze(StatusCodeMessages);

module.exports = {
  StatusCodeMessages,
};
